import React from "react";

const ObituaryListBanner = ({ image, label, alt, h1Text, subtitleText = undefined }) => {
  const defaultAlt =
    label === "Osmrtnice"
      ? "osmrtnice ozadje"
      : label === "Pogrebi"
      ? "pogrebi ozadje"
      : label === "Lokalne cvetličarne"
      ? "ozadje za cvetličarne"
      : label === "Pogrebna podjetja"
      ? "ozadje za pogrebna podjetja"
      : `${label} ozadje`;

  const displayText =
    h1Text ||
    (label === "Osmrtnice"
      ? "Osmrtnice"
      : label === "Pogrebi"
      ? "Pogrebi"
      : label === "Lokalne cvetličarne"
      ? "Lokalne cvetličarne"
      : label === "Pogrebna podjetja"
      ? "Pogrebna podjetja"
      : label);

  return (
    <div className="relative w-full overflow-hidden mx-auto desktop:mt-[70.02px] mobile:mt-[45px] tablet:mt-[52px] flex justify-center items-center">
      <img
        src={image}
        alt={alt || defaultAlt}
        className="h-[300px] mobile:h-[192px] tablet:h-[220px] w-full object-cover"
      />
      {/* Previous code kept for reference exactly as requested.
      <h1
        className=" flex flex-col items-center justify-center
         py-4 px-6 mx-auto absolute rounded-lg border-2 border-[#FFFFFF] shadow-custom-light-dark-banner bg-gradient-to-r from-[#FFFFFF] to-[#FFFFFF50] backdrop-blur-sm
        text-[#1E2125] 
        mobile:text-[28px] text-[40px] 
        font-normal leading-[47px] mobile:leading-[33px] whitespace-nowrap"
      >
        {displayText}
      </h1>
      */}
      {/* 
          Visual Design & SEO Architecture:
          1. Glass Container: Fixed dimensions as per client design spec to ensure a consistent look regardless of text length (440px/350px/280px).
          2. Double H1 Strategy: Both the main label (e.g. Osmrtnice) and the subtitle (City/Region name) use <h1> tags to maximize SEO boost for location-specific routes.
          3. Typography: Using font weight 400 and leading-none to achieve the precise "light but readable" look required, with reduced gap between lines.
      */}
      <div className="flex flex-col items-center justify-center w-[440px] h-[130px] tablet:w-[350px] tablet:h-[110px] mobile:w-[280px] mobile:h-[90px] mx-auto absolute rounded-lg border-2 border-[#FFFFFF] shadow-custom-light-dark-banner bg-gradient-to-r from-[#FFFFFF] to-[#FFFFFF50] backdrop-blur-sm">
        {/* Primary Heading */}
<h1 className="flex flex-col items-center justify-center text-center leading-tight">
  <span className="text-[#3C3E41] mobile:text-[28px] tablet:text-[36px] text-[40px] font-[400]">
    {displayText}
  </span>

  {subtitleText ? (
    <span className="mt-1 text-[#0A85C2] mobile:text-[20px] tablet:text-[28px] text-[32px] font-[400] leading-tight">
      {subtitleText}
    </span>
  ) : null}
</h1>
      </div>
    </div>
  );
};
export default ObituaryListBanner;
